import { useContext } from "react";
import CiroDropdown, {
  ICiroDropdownOptionGroup,
} from "../../../../shared/CiroDropdown";
import {
  QueryBuilderFields,
  PowersearchFieldEnum,
} from "./PowersearchQueryRule";
import PowerUserFiltersContext from "../../../../../contexts/PowerUserFiltersContext";

const PowersearchFieldSelector = ({
  selectedField,
  setSelectedField,
  disabled,
}: {
  selectedField: string;
  setSelectedField: (field: string) => void;
  disabled?: boolean;
}) => {
  const { showErrorMessages } = useContext(PowerUserFiltersContext);
  const errorMessage =
    showErrorMessages && (!selectedField || selectedField === "~")
      ? "Please select a filter"
      : "";

  // Group fields by profile and company
  const profileFields = QueryBuilderFields.filter((field) =>
    [
      PowersearchFieldEnum.JobTitle,
      PowersearchFieldEnum.LinkedInProfileKeywords,
      PowersearchFieldEnum.ContactCity,
      PowersearchFieldEnum.ContactState,
      PowersearchFieldEnum.ContactCountry,
    ].includes(field.name as PowersearchFieldEnum),
  );

  const companyFields = QueryBuilderFields.filter((field) =>
    [
      PowersearchFieldEnum.CompanyIndustry,
      PowersearchFieldEnum.CompanyDescription,
      PowersearchFieldEnum.CompanyCity,
      PowersearchFieldEnum.CompanyState,
      PowersearchFieldEnum.CompanyCountryIso,
      PowersearchFieldEnum.CompanyHeadCountRange,
    ].includes(field.name as PowersearchFieldEnum),
  );

  const groupedOptions: ICiroDropdownOptionGroup<string>[] = [
    {
      label: "Company",
      options: companyFields.map((field) => ({
        label: field.label,
        value: field.name,
      })),
    },
    {
      label: "Profile",
      options: profileFields.map((field) => ({
        label: field.label,
        value: field.name,
      })),
    },
  ];

  return (
    <CiroDropdown
      isClearable={false}
      options={groupedOptions}
      isDisabled={disabled}
      value={selectedField}
      onChange={setSelectedField}
      menuPortalTarget={document.body}
      menuPlacement="top"
      error={errorMessage}
    />
  );
};

export default PowersearchFieldSelector;
